<template>
  <button
    type="button"
    class="theme-toggle"
    :title="isLight ? $t('theme.switchToDark') : $t('theme.switchToLight')"
    @click="handleToggle"
  >
    <!-- Light mode: sun (current). Dark mode: moon (current). -->
    <svg v-if="isLight" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
      <circle cx="12" cy="12" r="5"></circle>
      <line x1="12" y1="1" x2="12" y2="3"></line>
      <line x1="12" y1="21" x2="12" y2="23"></line>
      <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line>
      <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line>
      <line x1="1" y1="12" x2="3" y2="12"></line>
      <line x1="21" y1="12" x2="23" y2="12"></line>
      <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line>
      <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line>
    </svg>
    <svg v-else viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
      <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path>
    </svg>
  </button>
</template>

<script>
import { ref, onMounted, onUnmounted } from 'vue'
import { getTheme, toggleTheme, THEMES } from '@/utils/themeManager'

export default {
  name: 'ThemeToggle',
  setup() {
    const isLight = ref(getTheme() === THEMES.LIGHT)

    function syncTheme() {
      isLight.value = getTheme() === THEMES.LIGHT
    }

    onMounted(() => {
      syncTheme()
      window.addEventListener('mc-theme-change', syncTheme)
    })

    onUnmounted(() => {
      window.removeEventListener('mc-theme-change', syncTheme)
    })

    function handleToggle() {
      toggleTheme()
      syncTheme()
    }

    return { isLight, handleToggle }
  }
}
</script>

<style scoped>
.theme-toggle {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  color: var(--mc-body);
  background: transparent;
  border: none;
  border-radius: var(--mc-radius-md);
  cursor: pointer;
  transition: background var(--mc-transition-fast);
}

.theme-toggle svg {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}

.theme-toggle:active {
  background: var(--mc-surface-soft);
}
</style>
